<template>

<div class="container wrap container--translate--words justify-content-center">
  
  <slick ref="slick" :options="slickOptions" class="slick--character">

    <div class="card justify-content-center align-items-center">
      <div class="card__name container align-items-center">
        <span class="card__name__number container align-items-center justify-content-center">
          01
        </span>
        <p><span>Apprenctice</span><br> Everything has a beginning, this is yours!</p>
      </div>
      <div class="card__interior container align-items-center justify-content-center">
        <img class="bloogon bloog" src="@/assets/img/personagens/bloogApprentice.png" alt="Minds">
        <img class="card__interior__bg cor01" src="@/assets/img/personagens/bg/bg01.jpg" alt="Minds">
      </div>
    </div>

    <div class="card container justify-content-center align-items-center">
      <div class="card__name container align-items-center">
        <span class="card__name__number container align-items-center justify-content-center">
          02
        </span>
        <p><span>Planner</span><br> Planning solidifies your journey!</p>
      </div>
      <div class="card__interior container align-items-center justify-content-center">
        <img class="bloogoff bloog" src="@/assets/img/personagens/bloogApprentice.png" alt="Minds">
        <img class="card__interior__bg cor02" src="@/assets/img/personagens/bg/bg02.jpg" alt="Minds">
      </div>
    </div>

    <div class="card container justify-content-center align-items-center">
      <div class="card__name container align-items-center">
        <span class="card__name__number container align-items-center justify-content-center">
          03
        </span>
        <p><span>Browser</span><br> To find out, you have to search!</p>
      </div>
      <div class="card__interior container align-items-center justify-content-center">
        <img class="bloogoff bloog" src="@/assets/img/personagens/bloogApprentice.png" alt="Minds">
        <img class="card__interior__bg cor03" src="@/assets/img/personagens/bg/bg03.jpg" alt="Minds">
      </div>
    </div>

    <div class="card container justify-content-center align-items-center">
      <div class="card__name container align-items-center">
        <span class="card__name__number container align-items-center justify-content-center">
          02
        </span>
        <p><span>Planner</span><br> Planning solidifies your journey!</p>
      </div>
      <div class="card__interior container align-items-center justify-content-center">
        <img class="bloogoff bloog" src="@/assets/img/personagens/bloogApprentice.png" alt="Minds">
        <img class="card__interior__bg cor02" src="@/assets/img/personagens/bg/bg02.jpg" alt="Minds">
      </div>
    </div>

    <div class="card container justify-content-center align-items-center">
      <div class="card__name container align-items-center">
        <span class="card__name__number container align-items-center justify-content-center">
          03
        </span>
        <p><span>Browser</span><br> To find out, you have to search!</p>
      </div>
      <div class="card__interior container align-items-center justify-content-center">
        <img class="bloogoff bloog" src="@/assets/img/personagens/bloogApprentice.png" alt="Minds">
        <img class="card__interior__bg cor03" src="@/assets/img/personagens/bg/bg03.jpg" alt="Minds">
      </div>
    </div>
    
  </slick>

<!-- 01 COLOR MAP ONE -->
<filter id="cor01" x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
	<feColorMatrix type="matrix" values=".33 .33 .33 0 0
            .33 .33 .33 0 0
            .33 .33 .33 0 0
            0 0 0 1 0" in="SourceGraphic" result="colormatrix"/>
	<feComponentTransfer in="colormatrix" result="componentTransfer">
    		<feFuncR type="table" tableValues="0.52 0.86 0.97"/>
		<feFuncG type="table" tableValues="0 0.08 0.81"/>
		<feFuncB type="table" tableValues="0.51 0.24 0.05"/>
		<feFuncA type="table" tableValues="0 0.8"/>
  	</feComponentTransfer>
	<feBlend mode="normal" in="componentTransfer" in2="SourceGraphic" result="blend"/>
</filter>
<!-- FIM 01 COLOR MAP ONE -->

<!-- 02 COLOR MAP ONE -->
<filter id="cor02" x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
	<feColorMatrix type="matrix" values=".33 .33 .33 0 0
            .33 .33 .33 0 0
            .33 .33 .33 0 0
            0 0 0 1 0" in="SourceGraphic" result="colormatrix"/>
	<feComponentTransfer in="colormatrix" result="componentTransfer">
    		<feFuncR type="table" tableValues="0.02 0.13 0.8"/>
		<feFuncG type="table" tableValues="0.02 0.47 0.97"/>
		<feFuncB type="table" tableValues="0.26 0.52 0.48"/>
		<feFuncA type="table" tableValues="0 0.8"/>
  	</feComponentTransfer>
	<feBlend mode="normal" in="componentTransfer" in2="SourceGraphic" result="blend"/>
</filter>
<!-- FIM 02 COLOR MAP ONE -->

<!-- 03 COLOR MAP ONE -->
<filter id="cor03" x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
	<feColorMatrix type="matrix" values=".33 .33 .33 0 0
            .33 .33 .33 0 0
            .33 .33 .33 0 0
            0 0 0 1 0" in="SourceGraphic" result="colormatrix"/>
	<feComponentTransfer in="colormatrix" result="componentTransfer">
    		<feFuncR type="table" tableValues="0.27 0.86 1"/>
		<feFuncG type="table" tableValues="0.01 0.31 0.95"/>
		<feFuncB type="table" tableValues="0.02 0.02 0.02"/>
		<feFuncA type="table" tableValues="0 0.8"/>
  	</feComponentTransfer>
	<feBlend mode="normal" in="componentTransfer" in2="SourceGraphic" result="blend"/>
</filter>
<!-- FIM 03 COLOR MAP ONE -->

</div>
<!-- <div class="container wrap container--translate--words">
  <div v-for="(user, index) in data" class="userinfo--container col-12 col-xl-4 col-lg-4 col-md-6 col-sm-12">
    <div class="userinfo--container__stats container align-items-center justify-content-center">
      <div class="userinfo--container__stats--bg">
        <div class="userinfo--container__stats--bg--2">
          <svg width="150" class="circular-chart" x="0px" y="0px" viewBox="0 0 36 36" xml:space="preserve">
              <path class="circle2" stroke-dasharray="55, 55" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
              <path class="circle" :stroke-dasharray="`${getProgress(xp, user.level)}, 100`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
              <defs>
                <linearGradient id="MyGradient">
                  <stop offset="0%" stop-color="#7F00FD" />
                  <stop offset="100%" stop-color="#FFA200" />
                </linearGradient>
              </defs>
            </svg>
        </div>
      </div>
    </div>
    <div class="userinfo--container__box container column justify-content-center align-items-center">
      <div class="userinfo--stats" :class="{ blocked: user.level > level }">
        <img src="@/assets/img/personagens/2.svg" width="100" alt="Minds">
      </div>
      <div class="userinfo--container__box--class container justify-content-center">
        <div class="class-name">{{ getLevelName(user.level) }}</div>
      </div>
      <div class="userinfo--container__box--tag container justify-content-center">
        <div :class="'tag tag-' + user.tag">Nível {{ user.level }}</div>
      </div>
      <div class="userinfo--container__box--points container column justify-content-center align-items-center">
        <div class="points">
          {{ parseInt(xp) }}/{{ getTotal(user.level) }}
        </div>
        <div class="last-points">
          {{ getTotal(user.level) - parseInt(xp) }} para o nível {{ user.level + 1 }}
        </div>
      </div>
      <router-link :to="{ name: 'salaVirtual' }" class="btn btn-md btn-red btn-full btn-rounded">
        SALA VIRTUAL <i class="margin-left-5 fas fa-arrow-right"></i>
      </router-link>
    </div>
  </div>
</div> -->
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'unidades',
  data () {
    return {
      totalPoints: 800,
      slickOptions: {
        centerMode: true,
        pauseOnFocus: true,
        centerPadding: '0px',
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<button type="button" class="btn btn__slick btn__slick__prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 80"><defs><style>.a{fill:#fff;}</style></defs><g transform="translate(-55, -130), rotate(180 50 100)"><path class="a" d="M14.8,46a5.444,5.444,0,0,1-3.9-1.6,5.706,5.706,0,0,1-.2-8.1L23.4,23,10.6,9.6a5.729,5.729,0,1,1,8.3-7.9L35.4,19a5.741,5.741,0,0,1,0,7.9L18.9,44.2A5.54,5.54,0,0,1,14.8,46Z"/></g></svg></button>',
        nextArrow: '<button type="button" class="btn btn__slick btn__slick__next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 80"><defs><style>.a{fill:#fff;}</style></defs><g transform="translate(5, 20), rotate(0 50 100)"><path class="a" d="M14.8,46a5.444,5.444,0,0,1-3.9-1.6,5.706,5.706,0,0,1-.2-8.1L23.4,23,10.6,9.6a5.729,5.729,0,1,1,8.3-7.9L35.4,19a5.741,5.741,0,0,1,0,7.9L18.9,44.2A5.54,5.54,0,0,1,14.8,46Z"/></g></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          }
        ]
      }
    }
  },
  props: {
    data: {
      type: Array
    }
  },
  computed: {
    level () {
      return this.$store.getters['student/GET'].level
    },
    xp () {
      return this.$store.getters['student/GET'].xp
    }
  },
  components: {
    Slick
  },
  methods: {
    getLevelName (level) {
      switch (level) {
        case 1:
          return 'Apprentice'
          break
        case 2:
          return 'Planner'
          break
        case 3:
          return 'Browser'
          break
        case 4:
          return 'Explorer'
          break
        case 5:
          return 'Colonizer'
          break
        case 6:
          return 'Knight'
          break
        case 7:
          return 'Grand Duke'
          break
        case 8:
          return 'Imperial Prince'
          break
        case 9:
          return 'Emperor'
          break
        default:
          return 'Apprentice'
      }
    },
    getTotal (level) {
      return parseInt(level) * 800
    },
    getProgress (xp, level) {
      if (level > this.level) xp = 0
      let progress = (xp * 55) / this.getTotal(level)
      if (progress > 55) progress = 55
      progress = Math.trunc(progress)
      return progress
    }
  }
}
</script>

<style lang="scss" scoped>

// Ajuste

.bloogoff{
  filter: opacity(.9) brightness(0) blur(4px)!important;
}
.bloogon{
  filter: drop-shadow(-1px 0 1px rgba(255, 0, 64, 0.61)) drop-shadow(1px 0 1px rgba(0, 255, 255, 0.705));
}


.slick--character{
  width: calc(100% - 50px);
  .slick-list .slick-track .slick-slide.slick-current.slick-active.slick-center{
    .card{
      opacity: 1;
      transform: scale(1);
    }
  }
}

#brnPrev{
      font-size: 0;
      line-height: 0;
      position: absolute;
      top: 50%;
      display: block;
      width: 20px;
      height: 20px;
      padding: 0;
      -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
      transform: translate(0, -50%);
      cursor: pointer;
      color: transparent;
      border: none;
      outline: none;
      background: transparent;
}

.card {
  // background: #edece0;
  background: url(../../assets/img/personagens/bg/bg02.png);
  background-size: cover;
  display: flex!important;
  width: 230px!important;
  height: 330px;
  overflow: hidden;
  position: relative;
  margin: 10px 0px 10px 0px;
  // margin-left: 15px;
  transform: scale(.9);
  border-radius: 10px;
  transition: .2s ease-in;
  border: 1px solid #9b9984;
  box-shadow: 3px 3px 5px -1px rgba(0, 0, 0, 0.4);
  filter: drop-shadow(-1px 0 1px red) drop-shadow(1px 0 1px cyan);

// &:hover{
//   transform: scale(1.1, 1.1) rotate(4deg) skew(0deg, 0deg);
//   box-shadow: 10px 18px 22px 1px rgba(0, 0, 0, 0.71);
//   filter: none;
//   z-index: 200;

// }
  &__name {
    background: #edece0;
    background: url(../../assets/img/personagens/bg/bg02.png);
    background-size: cover;
    width: 100%;
    height: 70px;
    padding: 10px 10px;
    border-radius: 50px 50px 0px 0px;
    position: absolute;
    bottom: 0px;
    justify-content: space-evenly;
    z-index: 2;

    &__number {
          background: #ffc200;
          color: #9c3e11;
          width: 50px;
          height: 50px;
          position: absolute;
          top: -40px;
          padding: 0px 5px 0px 0px;
          left: calc(50% - 25px);
          border-radius: 50%;
          font-size: 20px;
          font-weight: 400;
          box-shadow: inset 5px 5px 0px -1px #ffe3b2, inset -5px -5px 0px -1px #ff9c00;
          border: 2px solid #9c3e11;

      }
    p {
      text-align: center;
      // padding: 23px 120px;
      // margin-left: 10px;
      width: calc(100% - 20px);
      font-weight: 200;
      color: #555555;
      font-size: 13px;
        span{
          font-size: 20px;
          font-weight: 400;
          color: #9c3e11;
          text-transform: uppercase;
        }
      }
    h1 {
      // padding-top: 5px;
      // margin-top: -15px;
      position: absolute;
      font-size: 30px;
      text-align: center;
      text-transform: uppercase;
      font-weight: 400;
      letter-spacing: -1px;
      filter: drop-shadow( 0px -3px rgb(236, 232, 231)) drop-shadow( -2px 0px rgb(236, 232, 231)) drop-shadow( 3px 0px rgb(236, 232, 231));
      color: rgb(133, 0, 0);
    }
  }

  &__interior {
    // background: url(../../assets/img/personagens/bg/bg01.jpg), linear-gradient(#ce0000, #0e0000);
    // background-blend-mode: luminosity;
    // background-size: cover;
    width: 200px;
    height: 300px;
    border-radius: 10px;
    overflow: hidden;

    &__bg{
      // width: 100%;
      height: 100%;
      // position: absolute;
      // z-index: 1;
       &.cor01{
        filter: url('#cor01');
      }
       &.cor02{
        filter: url('#cor02');
      }
       &.cor03{
        filter: url('#cor03');
      }
    }

    .bloog {
      width: 120px;
      z-index: 1;
      position: absolute;
    }
  }
}

// .arrow-way {
//     background: #ccc;
//     width: 20px;
//     min-width: 20px;
//     height: 20px;
//     border-radius: 50%;
//     font-size: 12px;
//     line-height:20px;
//     opacity: 0.5;
//     cursor: pointer;
//     -webkit-transition: 0.1s;
//     transition: 0.1s;
//     &.arrow-left {
//         margin-right: 2px;
//     }
//     &.arrow-right {
//         margin-left: 2px;
//     }
//     &:hover {
//         opacity: 1;
//     }
//     svg {
//       vertical-align: -0.250em;
//     }
// }

// .userinfo--container__stats {
//     .userinfo--container__stats--bg {
//         width: 169px;
//         height: 100px;
//         max-width: 90%;
//         background: rgba(0, 0, 0, .1);
//         border-radius: 100px 100px 0 0;
//     }
//     .userinfo--container__stats--bg--2 {
//         width: 165px;
//         height: 100px;
//         max-width: 90%;
//         background: #fff;
//         border-radius: 100px 100px 0 0;
//         margin: 0 auto;
//     }
// }

// .userinfo--stats {
//     position: absolute;
//     top: 32px;
//     left: 0;
//     width: 100%;
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     -webkit-box-align: center;
//     -ms-flex-align: center;
//     align-items: center;
//     -webkit-box-pack: center;
//     -ms-flex-pack: center;
//     justify-content: center;
//     &.blocked img {
//       filter: blur(3px) brightness(10%);
//     }
// }

// .percent--user {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     -webkit-box-align: center;
//     -ms-flex-align: center;
//     align-items: center;
//     -webkit-box-pack: center;
//     -ms-flex-pack: center;
//     justify-content: center;
// }

// .userinfo--container {
//     position: relative;
//     .userinfo--container__box {
//         margin: 0 20px 20px;
//         padding: 15px;
//         -webkit-box-sizing: border-box;
//         box-sizing: border-box;
//         border-radius: 20px;
//         background-color: #fff;
//         -webkit-box-shadow: 10px 60px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);
//         box-shadow: 10px 60px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);
//         .userinfo--container__box--tag {
//             margin-top: 10px;
//         }
//         .userinfo--container__box--class {
//             width: 90%;
//             padding-top: 48px;
//             text-align: center;
//             .class-name {
//                 width: 100%;
//                 background: #ddd;
//                 height: 20px;
//                 border-radius: 20px;
//                 font-size: 14px;
//                 display: -webkit-box;
//                 display: -ms-flexbox;
//                 display: flex;
//                 -webkit-box-align: center;
//                 -ms-flex-align: center;
//                 align-items: center;
//                 -webkit-box-pack: center;
//                 -ms-flex-pack: center;
//                 justify-content: center;
//             }
//         }
//         .userinfo--container__box--points {
//             margin-top: 5px;
//             color: #2C2C2C;
//             .points {
//                 font-size: 14px;
//                 line-height: 16px;
//             }
//             .last-points {
//                 font-size: 8px;
//                 line-height: 11px;
//             }
//         }
//         .userinfo--container__box--btn {
//             margin-top: 18px;
//         }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/characters/index.vue